import { PolicyType, Relationship } from '../../../../../common';
import { IEidMembersForm } from '../../../with-eid-members/members-form/types';
import { IMembersForm } from '../../../without-eid-members';

export const isRelationshipCountValid = (
	formValues: IEidMembersForm | IMembersForm,
	selectedRelationship: Relationship,
	relationshipsToCount: Relationship[],
	maxCount = 1
) => {
	if (
		(formValues.policyTypeId === PolicyType.MeAndFamily || formValues.policyTypeId === PolicyType.OnlyFamily) &&
		relationshipsToCount.includes(selectedRelationship)
	) {
		const count =
			formValues.dependents?.filter((d) => d.relationshipTypeId && relationshipsToCount.includes(d.relationshipTypeId))
				.length ?? 0;

		return count <= maxCount;
	}

	return true;
};
